import type { Dispatch } from 'redux';
import { portalModalsActions } from '@/redux/modules';
import type { GatorProtectPortalModalsSlice } from './GatorProtectGlobals.types';

/** Fallback when `portalModals` slice is absent from root state (tests / edge hydration). */
export const FALLBACK_PORTAL_MODALS: GatorProtectPortalModalsSlice = { modals: [] };

/**
 * Clears portal modals Redux slice and restores header modal dismiss slots via the visibility reducer.
 * Shared by hooks that gate `GET /api/v3/modals` on home + `gator_protect`.
 */
export function resetPortalModalsGlobals(
  dispatch: Dispatch,
  resetModalsVisibility: () => void,
): void {
  dispatch(portalModalsActions.clear());
  resetModalsVisibility();
}
